import { render, staticRenderFns } from "./Background.vue?vue&type=template&id=48dc5c22&scoped=true&"
import script from "./Background.vue?vue&type=script&lang=js&"
export * from "./Background.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48dc5c22",
  null
  
)

export default component.exports